/**
 * The types of filters.
 * The objects that the filter is filtering.
 */
export var FilterType;
(function (FilterType) {
    FilterType["Film"] = "Film";
    FilterType["Showtime"] = "Showtime";
    FilterType["Subscription"] = "Subscription";
})(FilterType || (FilterType = {}));
//# sourceMappingURL=filter-type.js.map